export const saveFile = (content: BlobPart, type: string, fileName: string, extension: string) => {
  const blob = new Blob([content], { type: type });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.${extension}`;
  a.click();
}